import React from 'react';

export default function CheckoutCanceled() {
  return <h3>Your payment failed, please try again.</h3>;
}
